import React from 'react';
import { Content, ContentHeader, PageWithHeader } from '@backstage/core-components';
import { EntityListProvider } from '@backstage/plugin-catalog-react';
import { CreateProjectTable } from '../components/createProject/createProjectTable/CreateProjectTable';

export function CreateProjectPage() {
  return (
    <PageWithHeader title="Create Project" themeId="home">
      <Content>
        <ContentHeader title="" />
        <EntityListProvider>
          <CreateProjectTable />
        </EntityListProvider>
      </Content>
    </PageWithHeader>
  );
}
